//Please add the language resource
const planAppointmentLog = {
  serialNo: 'serialNo',
  outPlanNo: 'outPlanNo',
  planNo: 'planNo',
  truckNo: 'truckNo',
  driverName: 'driverName',
  driverTel: 'driverTel',
  planStatus: 'planStatus',
  dealStatus: 'dealStatus',
  dealCount: 'dealCount',
  dealTime: 'dealTime',
  dealResult: 'dealResult',
  originNo: 'originNo',
  planExpToDate: 'planExpToDate',
  planExpToTime: 'planExpToTime',
  orderNo: 'orderNo',
  createTime: 'createTime',
  detail: {
    originNo: 'originNo',
    planExpToDate: 'planExpToDate',
    planExpToTime: 'planExpToTime',
  },
  msg: {}
};
export default planAppointmentLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/planAppointmentLog/lang/planAppointmentLog.en.js